export default __webpack_public_path__ + "static/media/36I-102761_-15871_0.bf01d843.jpg";